"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionType = exports.RewardCardType = exports.LoyaltyOrderItemTypes = exports.RedemptionEventTypes = exports.EarningRuleSourceBanner = exports.EarningEventTypes = exports.LoyaltyEventType = exports.LoyaltyTransactionType = void 0;
var LoyaltyTransactionType;
(function (LoyaltyTransactionType) {
    LoyaltyTransactionType["EARNED"] = "Earned";
    LoyaltyTransactionType["REDEEMED"] = "Redeemed";
    LoyaltyTransactionType["EXPIRED"] = "Expired";
    LoyaltyTransactionType["ADJUSTMENT"] = "Adjustment";
})(LoyaltyTransactionType = exports.LoyaltyTransactionType || (exports.LoyaltyTransactionType = {}));
var LoyaltyEventType;
(function (LoyaltyEventType) {
    LoyaltyEventType["LOYALTY_POINTS_REWARDED"] = "customer.rewarded.loyalty_points";
    LoyaltyEventType["LOYALTY_CARD_POINTS_ADDED"] = "customer.voucher.loyalty_card.points_added";
    LoyaltyEventType["LOYALTY_POINTS_REDEEMED"] = "customer.redemption.succeeded";
    LoyaltyEventType["LOYALTY_POINTS_REDEMPTION_ROLLED_BACK"] = "customer.redemption.rollback.succeeded";
})(LoyaltyEventType = exports.LoyaltyEventType || (exports.LoyaltyEventType = {}));
var EarningEventTypes;
(function (EarningEventTypes) {
    EarningEventTypes["SIM_RENTAL_BOOKING"] = "Simulator Rental Booking";
    EarningEventTypes["LESSON_BOOKING"] = "Lesson Booking";
    EarningEventTypes["PARTY_BOOKING"] = "Party Booking";
    EarningEventTypes["SWING_EVAL"] = "Swing Evaluation Booking";
    EarningEventTypes["MEMBERSHIPS"] = "Membership Purchase";
    EarningEventTypes["FOOD_BEVERAGE_PURCHASE"] = "Food & Beverage Purchase";
    EarningEventTypes["OTHER"] = "Other Earnings";
    EarningEventTypes["POINTS_ADJUSTMENT"] = "Points Adjustment";
    EarningEventTypes["WEB_ORIGIN"] = "Website Booking Bonus";
    EarningEventTypes["APPLICATION_ORIGIN"] = "Application Origin Bonus";
    EarningEventTypes["LATE_NIGHT_BOOKING"] = "Late Night 2x Bonus Rewards";
})(EarningEventTypes = exports.EarningEventTypes || (exports.EarningEventTypes = {}));
var EarningRuleSourceBanner;
(function (EarningRuleSourceBanner) {
    EarningRuleSourceBanner["WEB_ORIGIN"] = "Web Origin";
    EarningRuleSourceBanner["APPLICATION_ORIGIN"] = "Application Origin";
    EarningRuleSourceBanner["LATE_NIGHT_BOOKING"] = "Late Night Booking";
})(EarningRuleSourceBanner = exports.EarningRuleSourceBanner || (exports.EarningRuleSourceBanner = {}));
var RedemptionEventTypes;
(function (RedemptionEventTypes) {
    RedemptionEventTypes["BOOKING_REDEMPTION"] = "Booking Redemption";
    RedemptionEventTypes["SQUARE_GIFT_CARD"] = "Food & Beverage Gift Card Redemption";
    RedemptionEventTypes["OTHER"] = "Other Redemption";
})(RedemptionEventTypes = exports.RedemptionEventTypes || (exports.RedemptionEventTypes = {}));
var LoyaltyOrderItemTypes;
(function (LoyaltyOrderItemTypes) {
    LoyaltyOrderItemTypes["SIMULATOR_RENTAL"] = "simulator rental";
    LoyaltyOrderItemTypes["BOWLING_RENTAL"] = "bowling rental";
    LoyaltyOrderItemTypes["GOLF_LESSON"] = "lesson";
    LoyaltyOrderItemTypes["SWING_EVAL"] = "swing evaluation";
    LoyaltyOrderItemTypes["PARTY_FEE"] = "party rental fee";
    LoyaltyOrderItemTypes["MEMBERSHIP"] = "membership";
})(LoyaltyOrderItemTypes = exports.LoyaltyOrderItemTypes || (exports.LoyaltyOrderItemTypes = {}));
var RewardCardType;
(function (RewardCardType) {
    RewardCardType["Food"] = "Food";
    RewardCardType["Simulator"] = "Simulator";
    RewardCardType["Group"] = "Group";
    RewardCardType["Lesson"] = "Lesson";
    RewardCardType["FirstLesson"] = "FirstLesson";
    RewardCardType["Bowling"] = "Bowling";
})(RewardCardType = exports.RewardCardType || (exports.RewardCardType = {}));
var TransactionType;
(function (TransactionType) {
    TransactionType["POINTS_ACCRUAL"] = "POINTS_ACCRUAL";
    TransactionType["POINTS_ADDITION"] = "POINTS_ADDITION";
    TransactionType["POINTS_REMOVAL"] = "POINTS_REMOVAL";
})(TransactionType = exports.TransactionType || (exports.TransactionType = {}));
//# sourceMappingURL=LoyaltyTypes.js.map